import axios from 'axios'

if (process.browser) {
  const token = window.localStorage.getItem('hvbToken')
  if (token) {
    axios.defaults.headers['Authorization'] = 'BEARER ' + token
  }
}

export default axios



// WEBPACK FOOTER //
// ./src/axios.js